<div class="programacao-form">
  <div class="campo-programacao">
    <span class="label-programacao">Tipo de Disparo (recorrente, padrão)</span>
    <app-select-one
      label=""
      placeholder="Selecione"
      heightFormField="40px"
      [listaInput]="tiposProgramacao"
      [habilitarBusca]="true"
      [itemSelecionado]="tipoProgramacao"
      [disabled]="disabled"
      (selecionarItem)="selecionarTipoProgramacao($event)">
    </app-select-one>
  </div>

  <div class="rotulo-destaque">
    <span class="label-programacao">Agendamento</span>
    <img
      class="icone-info"
      src="assets/icones/informativo-clari.svg"
      matTooltip="Você pode agendar uma data e horário para seu disparo. Caso deixe em branco, ele será disparado assim que clicar em ENVIAR."
      alt="Informação">
  </div>

  @if (tipoProgramacao === 'Padrão') {
    <div class="data-hora">
      <app-agendamento-disparo
        [dataSelecionada]="dataAgendamento"
        [horarioSelecionado]="horaAgendamento"
        [disabledData]="disabled"
        [disabledHorario]="disabled"
        (envioTempo)="atualizarAgendamentoPadrao($event)">
      </app-agendamento-disparo>
    </div>
  } @else {
    <div class="campo-programacao">
      <span class="label-programacao">Frequência</span>
      <div class="segmentos segmentos-frequencia">
        @for (opcao of frequencias; track opcao.valor) {
          <button
            type="button"
            class="segmento"
            [class.segmento--ativo]="programacao.frequencia === opcao.valor"
            [disabled]="disabled"
            (click)="selecionarFrequencia(opcao.valor)">
            {{ opcao.label }}
          </button>
        }
      </div>
    </div>

    @if (programacao.frequencia === 'Diário' || programacao.frequencia === 'Semanal' || programacao.frequencia === 'Personalizada') {
      <div class="card-configuracao">
        <div class="linha-stepper">
          <span>{{ programacao.frequencia === 'Personalizada' ? 'A cada' : 'Repetir a cada' }}</span>
          <button type="button" class="stepper" [disabled]="disabled || programacao.intervalo <= 1" (click)="ajustarValor('intervalo', -1)">−</button>
          <app-form-field
            classe="campo-stepper"
            type="number"
            widthFormField="44px"
            heightFormField="34px"
            [min]="1"
            [value]="programacao.intervalo"
            [disabled]="disabled"
            (changeValue)="atualizarValor('intervalo', $event)">
          </app-form-field>
          <button type="button" class="stepper" [disabled]="disabled" (click)="ajustarValor('intervalo', 1)">+</button>
          @if (programacao.frequencia === 'Diário') {
            <span>Dias</span>
          } @else if (programacao.frequencia === 'Semanal') {
            <span>Semanas</span>
          } @else {
            <app-select-one
              classe="select-recorrencia"
              campo="label"
              chaveCompare="valor"
              widthFormField="150px"
              heightFormField="40px"
              [listaInput]="unidadesPersonalizadas"
              [habilitarBusca]="true"
              [itemSelecionado]="obterUnidadeSelecionada()"
              [disabled]="disabled"
              (selecionarItem)="atualizarUnidadePersonalizada($event.valor)">
            </app-select-one>
          }
        </div>

        @if (programacao.frequencia === 'Semanal') {
          <app-dias-semana
            [diasSelecionados]="$any(programacao.diasSemana)"
            [disabled]="disabled"
            (diasSelecionadosChange)="atualizarDiasSemana($event)">
          </app-dias-semana>
        }

        @if (programacao.frequencia === 'Diário') {
          <div class="execucoes-diarias">
            <div class="linha-stepper">
              <span>Execuções por dia</span>
              <button type="button" class="stepper" [disabled]="disabled || horariosDiarios.length <= 1" (click)="ajustarQuantidadeHorarios(-1)">−</button>
              <strong>{{ horariosDiarios.length }}</strong>
              <button type="button" class="stepper" [disabled]="disabled || horariosDiarios.length >= 12" (click)="ajustarQuantidadeHorarios(1)">+</button>
            </div>
            <div class="grade-horarios">
              @for (horario of horariosDiarios; track $index) {
                <div class="flex-direction-column gap-5">
                  <app-time-picker-padrao
                    [tempo]="horario"
                    [labelExtra]="$index + 1 + 'ª geração'"
                    [disabled]="disabled"
                    [alinhamentoLateral]="true"
                    (envioHorarioSelecionado)="atualizarHorarioDiario($index, $event)">
                  </app-time-picker-padrao>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }

    @if (programacao.frequencia === 'Mensal') {
      <div class="card-configuracao mensal">
        <div class="segmentos segmentos-mensais">
          <button type="button" class="segmento segmento-mensal" [class.segmento--ativo]="programacao.tipoRecorrenciaMensal === tiposMensais.DIA_DO_MES" [disabled]="disabled" (click)="selecionarTipoMensal(tiposMensais.DIA_DO_MES)">
            <strong>Dia do Mês</strong><small>Ex: Todo dia 5</small>
          </button>
          <button type="button" class="segmento segmento-mensal" [class.segmento--ativo]="programacao.tipoRecorrenciaMensal === tiposMensais.DIA_DA_SEMANA" [disabled]="disabled" (click)="selecionarTipoMensal(tiposMensais.DIA_DA_SEMANA)">
            <strong>Dia da Semana</strong><small>Ex: 1ª Segunda-feira do Mês</small>
          </button>
        </div>

        @if (programacao.tipoRecorrenciaMensal === tiposMensais.DIA_DO_MES) {
          <div class="linha-stepper">
            <span>No dia</span>
            <button type="button" class="stepper" [disabled]="disabled || !!programacao.ultimoDiaMes || (programacao.diaMes ?? 1) <= 1" (click)="ajustarValor('diaMes', -1, 31)">−</button>
            <app-form-field
              classe="campo-stepper"
              type="number"
              widthFormField="44px"
              heightFormField="34px"
              [min]="1"
              [max]="31"
              [value]="programacao.diaMes ?? 1"
              [disabled]="disabled || !!programacao.ultimoDiaMes"
              (changeValue)="atualizarValor('diaMes', $event, 31)">
            </app-form-field>
            <button type="button" class="stepper" [disabled]="disabled || !!programacao.ultimoDiaMes || (programacao.diaMes ?? 1) >= 31" (click)="ajustarValor('diaMes', 1, 31)">+</button>
          </div>
          <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -- app-form-field envolve um mat-checkbox nativo, mas o linter não enxerga o input interno do componente filho -->
          <label class="checkbox-recorrencia">
            <app-form-field
              [isCheckbox]="true"
              [value]="!!programacao.ultimoDiaMes"
              [disabled]="disabled"
              (changeValue)="alternarUltimoDiaMes($event)">
            </app-form-field>
            Último dia do Mês
          </label>
          <div class="linha-stepper">
            <span>Repetir a cada</span>
            <button type="button" class="stepper" [disabled]="disabled || programacao.intervalo <= 1" (click)="ajustarValor('intervalo', -1)">−</button>
            <app-form-field
              classe="campo-stepper"
              type="number"
              widthFormField="44px"
              heightFormField="34px"
              [min]="1"
              [value]="programacao.intervalo"
              [disabled]="disabled"
              (changeValue)="atualizarValor('intervalo', $event)">
            </app-form-field>
            <button type="button" class="stepper" [disabled]="disabled" (click)="ajustarValor('intervalo', 1)">+</button>
            <span>Meses</span>
          </div>
        } @else {
          <div class="selects-mensais">
            <app-select-one
              classe="select-recorrencia"
              campo="label"
              chaveCompare="valor"
              heightFormField="40px"
              [listaInput]="posicoes"
              [habilitarBusca]="true"
              [itemSelecionado]="obterPosicaoSelecionada()"
              [disabled]="disabled"
              (selecionarItem)="atualizarPosicao($event.valor)">
            </app-select-one>
            <app-select-one
              classe="select-recorrencia"
              campo="label"
              chaveCompare="valor"
              heightFormField="40px"
              [listaInput]="diasSemanaMes"
              [habilitarBusca]="true"
              [itemSelecionado]="obterDiaSemanaSelecionado()"
              [disabled]="disabled"
              (selecionarItem)="atualizarDiaSemanaMes($event.valor)">
            </app-select-one>
          </div>
        }
      </div>
    }

    <div class="data-hora">
      <app-agendamento-disparo
        labelData="Data da próxima geração"
        [dataSelecionada]="dataInicioSelecionada"
        [dataMinima]="dataMinimaInicio"
        [horarioSelecionado]="programacao.hora"
        [disabledData]="disabled"
        [disabledHorario]="disabled || programacao.frequencia === 'Diário'"
        (envioTempo)="atualizarInicio($event)">
      </app-agendamento-disparo>
    </div>

    <div class="campo-programacao termino">
      <span class="label-programacao">Término</span>
      <div class="segmentos segmentos-termino">
        @for (opcao of terminos; track opcao.valor) {
          <button type="button" class="segmento" [class.segmento--ativo]="programacao.tipoTermino === opcao.valor" [disabled]="disabled" (click)="selecionarTermino(opcao.valor)">
            {{ opcao.label }}
          </button>
        }
      </div>

      @if (programacao.tipoTermino === 'Data') {
        <div class="data-termino">
          <app-date-picker-padrao
            label="Data Término"
            placeholder="dd/mm/aaaa"
            [data]="dataTerminoSelecionada"
            [dataMinima]="dataInicioSelecionada ?? dataMinimaInicio"
            [disabled]="disabled"
            (envioDataSelecionada)="atualizarDataTermino($event)">
          </app-date-picker-padrao>
        </div>
      } @else if (programacao.tipoTermino === 'N. de Envios') {
        <div class="card-configuracao linha-stepper">
          <span>Após</span>
          <button type="button" class="stepper" [disabled]="disabled || (programacao.numeroEnviosTermino ?? 1) <= 1" (click)="ajustarValor('numeroEnviosTermino', -1)">−</button>
          <app-form-field
            classe="campo-stepper"
            type="number"
            widthFormField="44px"
            heightFormField="34px"
            [min]="1"
            [value]="programacao.numeroEnviosTermino ?? 1"
            [disabled]="disabled"
            (changeValue)="atualizarValor('numeroEnviosTermino', $event)">
          </app-form-field>
          <button type="button" class="stepper" [disabled]="disabled" (click)="ajustarValor('numeroEnviosTermino', 1)">+</button>
          <span>Envios</span>
        </div>
      }
    </div>
  }
</div>
